<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
              <th scope="col">نام</th>
              <th scope="col">نام خانوادگی</th>
              <th scope="col">سمت</th>
              <th scope="col">نام شرکت</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ firstName }}</td>
              <td>{{ lastName }}</td>
              <td>{{ postTitle }}</td>
              <td>{{ companyTitle }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr class="horizontal dark" />
      <div class="card-body">
        <h5>نقش های کنونی کاربر:</h5>
        <table class="table table-striped table-styled table-sm">
          <tbody>
            <template v-for="(r, index) in currentRoles">
              <tr v-if="!r.isDeleted">
                <td style="width: 10%">{{ index + 1 }}</td>
                <td style="width: 40%">{{ r.roleTitle ?? r.title }}</td>
                <td style="width: 20%">
                  <button class="btn btn-sm bg-gradient-danger mb-0" @click="removeRole(r)">
                    حذف
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <hr class="horizontal dark" />
        <h5>سایر نقش های مجاز برای کاربر:</h5>
        <table class="table table-striped table-styled table-sm">
          <tbody>
            <tr v-for="(r, index) in roles">
              <td style="width: 10%">{{ index + 1 }}</td>
              <td style="width: 40%">{{ r.title }}</td>
              <td style="width: 20%">
                <button class="btn btn-sm bg-gradient-success mb-0" @click="addRole(r)">
                  افزودن
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="horizontal dark" />
        <button type="button" class="btn bg-gradient-success mb-0" @click="submit()">ثبت تغییرات</button>
        <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
      </div>
    </div>
  </div>
</template>
<script>
  import UserService from '@/services/User/User-service.js';
  import RoleService from '@/services/User/Role-service.js';

  export default {
    data() {
      return {
        userId: null,
        postTitle: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        username: '',
        companyId: null,
        customerId: null,
        companyTitle: '',
        customerTitle: '',
        currentRoles: [],
        roles: []
      };
    },
    methods: {
      getUser() {
        UserService.find(this.userId).then(response => {
          let result = response.data;
          if (result.success) {
            this.postTitle = result.data.postTitle;
            this.firstName = result.data.firstName;
            this.lastName = result.data.lastName;
            this.email = result.data.email;
            this.phone = result.data.phone;
            this.username = result.data.username;
            this.companyId = result.data.companyId;
            this.companyTitle = result.data.companyTitle;
          } else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      goBack() {
        this.$router.back();
      },
      getUserRoles() {
        UserService.getUserRoles(this.userId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.currentRoles = result.data.map((role) => ({ ...role, isNew: false, isDeleted: false }));

            setTimeout(() => this.getRoles(), 100);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      removeRole(role) {
        if (role.isNew == true) {
          const index = this.currentRoles.map(x => x.roleId).indexOf(role.roleId);

          if (index > -1) {
            this.currentRoles.splice(index, 1);
          }
        }
        else {
          role.isDeleted = true;
        }
        this.roles.push(role);
      },
      getRoles() {
        RoleService.getRolesByCompanyId(this.companyId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.roles = result.data;

            this.currentRoles.forEach((role) => {
              let index = this.roles.map(x => x.id).findIndex((x) => {return x == role.roleId; });
              
              if (index > -1) { this.roles.splice(index, 1) }
            });
          }
        }).catch(e => {
          console.log(e);
        });
      },
      addRole(role) {
        const index = this.currentRoles.map(x => x.roleId).indexOf(role.id);

        if (index == -1) {
          this.currentRoles.push({
            ...role,
            roleId: role.id,
            isNew: true,
            isDeleted: false
          });
        }
        else if (this.currentRoles[index].isDeleted) {
          this.currentRoles[index].isDeleted = false;
        }
        let rolesIndex = this.roles.map(x => x.id).indexOf(role.id);

        this.roles.splice(rolesIndex, 1);
      },
      submit() {
        let list = this.currentRoles.filter((role) => !role.isDeleted).map((role) => ({ RoleId: (role.roleId ?? role.id), UserId: this.userId }));

        UserService.modifyUserRoles(list, this.userId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
            this.goBack();
          }
        }).catch(e => {
          console.log(e);
        });
      },
      goBack() {
        this.$router.back();
      }
    },
    created() {
      this.new = this.$route.meta.new;
      this.userId = this.$route.params.userId;
      this.getUser();
      this.getUserRoles();
    }
  }
</script>
